import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { routes } from "constants/routes";
const PrivateRoutes = () => {
  const authContext = useAuth();
  const location = useLocation();
  
  // Preserve query parameters when redirecting to login
  const loginPath = `${routes.login}${location.search}`;
  
  return !!authContext?.user ? <Outlet /> : <Navigate to={loginPath} />;
};

export default PrivateRoutes;
